import React from "react"
import Card, { CardWithSelection } from "../Card"
import NovelCard from "../NovelCard"
import Title from "../Card/Title"
import Subtitle from "../Card/Subtitle"
import Text from "../Card/Text"
import Icon from "../Card/Icon"
import { PremiumEpisodeOverlay, PremiumEpisodeLabel } from "./PremiumEpisode"
import { NovelCardWithSelection } from "../NovelCard/index";

const EpisodeCard = ({
  img,
  title,
  published_on,
  pageCount,
  likesCount,
  commentCount,
  selected,
  onClick,
  upNext,
  isNovel,
  ...overlayProps
}) => {
  if (isNovel) {
    const CardComponent = selected ? NovelCardWithSelection : NovelCard
    return (
      <div className="dib tl t-mr3">
        <CardComponent
          title={title}
          published_on={published_on}
          onClick={onClick}
          premium={overlayProps}
          likesCount={likesCount}
          commentCount={commentCount}
          selected={selected}
          upNext={upNext}
        />
      </div>
    )
  } else {
    const CardComponent = selected ? CardWithSelection : Card
    return (
      <div className="dib tl t-mr3">
        <CardComponent
          img={img}
          selected={selected}
          onClick={onClick}
          upNext={upNext}
          imgOverlay={<PremiumEpisodeOverlay {...overlayProps} />}
        >
          <Title>{title}</Title>
          <Subtitle>{pageCount} </Subtitle>
          <Text className="t-pt2">
            <Icon url="/images/pop-like-icon.svg" className="t-pr2">
              {" "}
              {likesCount}{" "}
            </Icon>
            <Icon url="/images/pop-comment-icon.svg"> {commentCount} </Icon>
          </Text>
        </CardComponent>
      </div>
    )
  }
}

EpisodeCard.defaultProps = {
  img: "/images/sample_images/sample_jpg.jpg",
  title: "Episode 1",
  pageCount: "17 pages",
  likesCount: 17,
  commentCount: 201,
  selected: false
}

export default EpisodeCard
